type GetSizeGuideIdProps = {
  sizeGuideUrl: string;
};

export const getSizeGuideId = ({
  sizeGuideUrl,
}: GetSizeGuideIdProps): number | null => {
  if (!sizeGuideUrl) {
    return null;
  }
  const match = sizeGuideUrl.match(/SizeGuide\/(\d+)(?:%3f|%3F|\?)/);
  const id =
    match && typeof match[1] === "string" ? parseInt(match[1], 10) : null;

  return id;
};
